import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import style from './style.module.scss'

const CalendarScheduler = () => {
  const user = useSelector(state => state.user)
  const fullName = user.name.split(' ', 2)
  const firstName = fullName[0] ? encodeURIComponent(fullName[0]) : ''
  const lastName = fullName[1] ? encodeURIComponent(fullName[1]) : ''
  const email = encodeURIComponent(user.email)
  const company =
    user.meta && user.meta.externalCompanyName
      ? encodeURIComponent(user.meta.externalCompanyName)
      : ''
  const RightHandSideContainerClasses = `${style.RightHandSideContainer} col-xl-6 col-md-12 col-xs-12 col-sm-12`

  const iframeSrcURL = `https://go.cometchat.com/meetings/ccmeet/meet-with-cometchat?embed=true&firstname=${firstName}&lastname=${lastName}&email=${email}&company=${company}`

  return (
    <div className={RightHandSideContainerClasses}>
      <div className={style.RightHandSideContainerInner}>
        <div className={style.RightHandSideContainerWrapper}>
          <script
            type="text/javascript"
            src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
          />

          <iframe
            title="Calendar"
            src={iframeSrcURL}
            height="100%"
            width="100%"
            style={{ border: '0px' }}
          />
        </div>
      </div>
    </div>
  )
}

export const CalendarSchedulerPure = memo(CalendarScheduler)

export default CalendarSchedulerPure
